module.exports = __webpack_public_path__ + "img/artist_header_es.b608cc6.webp";